/**
 * @fileoverview Own the browser's selected matter context and task-refresh coordination. `action.js` supplies explicit transitions; backend case records remain canonical. Matter identity must be replaced when navigation changes rather than reusing another case's pending result.
 */

import {
    SET_MATTER,
    SET_REFRESH_TRELLO_TASKS
} from './action';

const initialState = {}



const caseDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MATTER:
            return { ...state, matter: action.payload };
        case SET_REFRESH_TRELLO_TASKS:
            return { ...state, refreshTrelloTasks: action.payload };
        default:
            return state;
    }
}

export default caseDetailsReducer;